<div class="receipt-breakdown-row d-flex justify-content-between">
  <p class="receipt-breakdown-row--content-left flex-grow-1">
    <ng-content select="[leftProjection]"></ng-content>
  </p>
  @if (hasRightPart) {
    <p class="receipt-breakdown-row--content-right flex-grow-1 text-end">
      <ng-content select="[rightProjection]"></ng-content>
    </p>
  }
</div>
@if (separator) {
  <hr class="receipt-breakdown-row--separator" />
}
